<template>
	<div class="MAM_stockList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="stockForm" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="stockForm.real_name" placeholder="申请人"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.agent_no" placeholder="申请人编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.apply_num" placeholder="申请单号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="stockForm.phone" placeholder="申请人账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size clearable v-model="stockForm.status" placeholder="兑换状态" style="width:180px;">
						<el-option label="全部" value="">全部</el-option>
						<el-option label="未兑换" :value="0">未兑换</el-option>
						<el-option label="已兑换" :value="1">已兑换</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(stockForm)">查询</el-button>
					<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
						:loading="downLoading" @click="handleDownLoad(stockForm)">导出数据</el-button>	
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading"
				@selection-change="changeFun">
				<el-table-column type="selection" width="55" :selectable="selectable">
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="apply_num" label="申请单号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="real_name" label="申请人" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="申请人编号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="申请人账号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="nums" label="兑换台数"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="apply_time" label="申请时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="兑换状态" min-width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">未兑换</span>
						<span v-if="scope.row.status == 1" style="color: #F56C6C;">已兑换</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="120">
					<template slot-scope="scope">
						<el-button @click="handleInfo(scope.row)" type="text" size="small">查看申请单</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>


		<el-dialog title="兑换申请单" :visible.sync="dialogVisible" width="60%">

			<el-table :data="detailsTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="sn" label="终端SN"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="term_type" label="终端型号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_type_text" label="终端类型"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="兑换状态" min-width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">未兑换</span>
						<span v-if="scope.row.status == 1" style="color: #F56C6C;">已兑换</span>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="detailspage.detailscurrentPage" :pageSize="detailspage.detailspageSize"
				:total="detailspage.detailstotal" @watchCurrent="detailsgetCurrent" @watchPageSize="detailsgetPageSize">
			</paginations>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" v-if="detailsState == 0">取 消</el-button>
				<el-button @click="dialogVisible = false" v-if="detailsState == 1">关 闭</el-button>
				<el-button type="primary" @click="detailsSub" v-if="detailsState == 0">确认兑换</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "exchangeManagement",
		data() {
			return {
				level: sessionStorage.getItem('level'),
				rangeDate: '',
				stockForm: {
					real_name: '',
					phone: '',
					agent_no: '',
					status: 0,
					apply_num: '',
					start_time: '',
					end_time: '',
				},
				stockTable: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,

				//弹框
				dialogVisible: false,
				detailsState: false,
				detailsTable: {
					list: [],
				},
				detailspage: {
					detailscurrentPage: 1, //当前页码
					detailspageSize: 10, //条数
					detailstotal: 0 //总数
				},
				detailsForm: {
					page: 1,
					limit: 10,
					apply_id: null,
					user_id: null,
				},
				//导出
				downLoading:false,
				listRow: [],
			}
		},
		mounted() {
			//初始化
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				status: 0,
			})
		},
		components: {
			paginations,
		},
		methods: {
			//勾选
			changeFun(row) {
				this.listRow = row;
			},
			selectable(row, index) {
				if (row.status == 1) {
					return true; //不禁用
				} else {
					return false; //禁用
				}
			},
			//导出
			handleDownLoad(params) { 
				if(this.listRow.length == 0){
					this.$message.error('请勾选已兑换的数据');
					return false;
				}
				let arr = [];
				this.listRow.map(res=>{
					arr.push(res.id)
				})
				params.apply_id = arr.join(',')
				let reqData = {
					type: 16,
					value: JSON.stringify(params),
				};
				
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			//查看申请单
			handleInfo(row, state) {
				this.detailsState = row.status;
				this.detailsForm = {
					page: 1,
					limit: 10,
					apply_id: row.id,
					user_id: row.user_id,
				}
				this.detailsgetData(this.detailsForm);
				this.dialogVisible = true;
			},
			//分页
			detailsgetCurrent(page) {
				// 获取当前页修改的值
				this.loading = true;
				this.detailspage.detailscurrentPage = page;
				this.detailsForm.page = page;
				this.detailsForm.limit = this.detailspage.detailspageSize;
				this.detailsgetData(this.detailsForm);
			},
			detailsgetPageSize(limit) {
				this.detailspage.detailscurrentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.detailspage.detailspageSize = limit;
				this.detailsForm.page = page;
				this.detailsForm.limit = this.detailspage.detailspageSize;
				this.detailsgetData(this.detailsForm);
			},
			detailsgetData(params) {
				this.$api.post("terminal_exchange/TerminalExchangeRecord", params, res => {
					let data = res.data;
					this.detailspage.detailstotal = data.total; //总数
					this.detailsTable.list = data.data;
					//渲染结束后取消加载
					this.loading = false;
				});
			},
			//确定兑换
			detailsSub() {
				let data = {
					apply_id: this.detailsForm.apply_id,
					user_id: this.detailsForm.user_id,
				}
				this.$api.post("terminal_exchange/confirmApply", data, res => {
					if (res.code == 0) {
						let data = res.data;
						this.detailspage.detailstotal = data.count; //总数
						this.detailsTable.list = data.list;
						this.$message.success({
							type: 'success',
							message: '兑换成功',
						});
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				});
			},



			pickerChange(DateArr) { //时间选择器
				this.stockForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.stockForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},

			onSearch(stockForm) {
				this.page.currentPage = 1;
				stockForm.page = this.page.currentPage;
				stockForm.limit = this.page.pageSize;
				// 表单提交
				this.getData(stockForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.loading = true;
				this.page.currentPage = page;
				this.stockForm.page = page;
				this.stockForm.limit = this.page.pageSize;
				this.getData(this.stockForm)
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.page.pageSize = limit;
				this.stockForm.page = this.page.currentPage;
				this.stockForm.limit = limit;
				this.getData(this.stockForm);
			},
			getData(params) {
				this.$api.post("terminal_exchange/TerminalExchangePage", params, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.stockTable.list = data.data;
					//渲染结束后取消加载
					this.loading = false;
				});
			}
		},

	};
</script>

<style lang="scss" scope>
	.MAM_stockList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>